import { AnyAction } from 'redux';
import {
  AdressvorschlagFailedPayload,
  AdressvorschlagPayload,
  CALLER_ID,
  GlobalActions,
} from '@ps20-frontend/shop-integration-redux';
import { Adressvorschlag } from '@ps20-frontend/frontend-models';
import { CheckoutActions } from '../checkout.actions';

export interface MeldebehoerdeAngaben {
  isMeldebehoerdeVorhanden: boolean;
  behoerdename: string;
  aktenzeichen: string;
  isAktenzeichenUnbekannt: boolean;
  plz: string;
  ort: string;
  strasse: string;
  hausnummer: string;
  adressvorschlag: Adressvorschlag;
  beginnSicherungsbestaetigung: string;
}

export const meldebehoerdeAngabenReducer = function (
  sectionState: MeldebehoerdeAngaben = null,
  action: AnyAction,
): MeldebehoerdeAngaben {
  switch (action.type) {
    case CheckoutActions.MELDEBEHOERDE_VORHANDEN_CHANGED: {
      return { ...sectionState, isMeldebehoerdeVorhanden: action.payload };
    }
    case CheckoutActions.MELDEBEHOERDE_NAME_CHANGED: {
      return { ...sectionState, behoerdename: action.payload };
    }

    case CheckoutActions.MELDEBEHOERDE_AKTENZEICHEN_CHANGED: {
      return { ...sectionState, aktenzeichen: action.payload };
    }
    case CheckoutActions.MELDEBEHOERDE_STRASSE_CHANGED: {
      return { ...sectionState, strasse: action.payload };
    }

    case CheckoutActions.MELDEBEHOERDE_HAUSNUMMER_CHANGED: {
      return { ...sectionState, hausnummer: action.payload };
    }

    case CheckoutActions.MELDEBEHOERDE_PLZ_CHANGED: {
      return {
        ...sectionState,
        plz: action.payload,
        ort: null,
        strasse: null,
        hausnummer: null,
        adressvorschlag: {
          lastError: null,
          orte: [],
          strassen: [],
        },
      };
    }

    case CheckoutActions.MELDEBEHOERDE_AKTENZEICHEN_VORHANDEN_CHANGED: {
      if (action.payload) {
        sectionState.aktenzeichen = null;
      }
      return { ...sectionState, isAktenzeichenUnbekannt: action.payload };
    }

    case CheckoutActions.MELDEBEHOERDE_ORT_CHANGED: {
      return { ...sectionState, ort: action.payload };
    }

    case CheckoutActions.MELDEBEHOERDE_SICHERUNGSDATUM_CHANGED: {
      return { ...sectionState, beginnSicherungsbestaetigung: action.payload };
    }

    case GlobalActions.ADDRESSVORSCHLAG_SUCCESSFUL: {
      const payload: AdressvorschlagPayload = action.payload;
      if (payload.callerId !== CALLER_ID.THH_HUND_MELDEBEHOERDE) {
        return sectionState;
      }
      return {
        ...sectionState,
        adressvorschlag: {
          ...sectionState.adressvorschlag,
          lastError: null,
          orte: payload.orte,
          strassen: payload.strassen,
        },
        ort: payload.orte?.length === 1 ? payload.orte[0] : null,
      };
    }

    case GlobalActions.ADDRESSVORSCHLAG_FAILED: {
      const payload: AdressvorschlagFailedPayload = action.payload;
      if (payload.callerId !== CALLER_ID.THH_HUND_MELDEBEHOERDE) {
        return sectionState;
      }

      return {
        ...sectionState,
        adressvorschlag: {
          lastError: payload.reason,
          orte: [],
          strassen: [],
        },
      };
    }

    default:
      return sectionState;
  }
};
